var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},_vm._l((_vm.linkCardData),function(data,index){return _c('div',{key:index},[_c('linkCardContainer',{attrs:{"linkCardData":data.links,"title":data.category,"color":data.color}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }